import { IUserInfo, EnterpriseRoleType } from '@umu/umu-types';
/**
 * 是否系统管理员
 */
export const isEnterpriseAdmin = (userInfo: IUserInfo) => {
    if (!userInfo || !userInfo.enterprise_info) {
        return false;
    }
    return `${userInfo.enterprise_info.role_type}` === EnterpriseRoleType.ADMIN.toString();
};
